import {datadogRum} from '@datadog/browser-rum'

export default defineNuxtPlugin(() => {
    const config = useRuntimeConfig()
    datadogRum.init({
        applicationId: config.public.ddRumAppId,
        clientToken: config.public.ddRumClientToken,
        site: 'datadoghq.eu',
        service: 'myefficiency-front',
        env: config.public.env,
        // Specify a version number to identify the deployed version of your application in Datadog
        version: config.public.version,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend(event) {
            if (
                event.type === 'error' &&
                event.error?.message?.includes(
                    'ResizeObserver loop completed with undelivered notifications'
                )
            ) {
                return false // ❌ on n’envoie PAS au RUM
            }
            return true
        },
    })
})
